import PayMeBadge from "./PayMeBadge.vue";
import SplitBadge from "./SplitBadge.vue";

export default {
	PayMeBadge,
	SplitBadge
};
